import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { OlJourneyPlace } from '../../../lib/types/models/ol/ol-journey-place'
import { encodeNestedObject } from '../../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function getOlJourneyPlaces(data: { olId: number; input?: PaginationRequest }) {
  const { olId, input } = data
  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest>(
        constructApiUrl(API.ols.getOlJourneyPlaces.url, { id: olId }),
        input
      )
    )
    .get<PaginationResponse<OlJourneyPlace>>()
}
